var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20h20V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.835 12.285c.291 0 .528.237.528.528h0v3.449A1.74 1.74 0 0114.623 18h0-2.259a.528.528 0 010-1.054h2.26a.685.685 0 00.684-.684h0v-3.45c0-.29.236-.527.527-.527zM14.624 2c.96 0 1.739.78 1.739 1.739h0v4.104a.527.527 0 01-1.055 0h0V3.739a.686.686 0 00-.684-.685h0-9.886a.685.685 0 00-.683.685h0v12.523c0 .377.306.684.683.684h2.614a.527.527 0 110 1.054h0-2.614A1.74 1.74 0 013 16.262h0V3.74c0-.96.78-1.74 1.738-1.74h0z",
    stroke: "#191C26",
    strokeWidth: 0.2,
    fill: "#191C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.454 9.672l-6.115 7.25a.6.6 0 10.908.785l6.116-7.25a.602.602 0 00-.062-.847.604.604 0 00-.847.062z",
    stroke: "#3B65EE",
    strokeWidth: 0.1,
    fill: "#3B65EE"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/assets/icon-edit.0a52cfee.svg";
export { ForwardRef as ReactComponent };